<template>
  <div>
    <el-breadcrumb separator="/" class="page-breadcrumb">
      <el-breadcrumb-item>社区信息管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card shadow="never" class="page-content">
      <div class="page-actions">
        <el-button type="primary" class="btn" @click="openDialog"
          >添加社区</el-button
        >
        <el-select
          v-model="language"
          placeholder="请选择语言"
          @change="refreshList"
        >
          <el-option
            v-for="item in languageList"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </div>
      <el-table :data="communityList">
        <el-table-column label="账号" prop="account"></el-table-column>
        <el-table-column
          label="社区名称"
          prop="communityName"
        ></el-table-column>
        <el-table-column label="描述" prop="description"></el-table-column>
        <!-- <el-table-column label="图标url" prop="icon"></el-table-column> -->
        <el-table-column label="图标" prop="icon">
          <template slot-scope="scope">
            <image-wrapper :src="scope.row.icon" style="width: 50px;"></image-wrapper>
          </template>
        </el-table-column>
        <el-table-column label="语言" prop="language"></el-table-column>
        <el-table-column
          label="二维码url"
          prop="twoDimensionCode"
        >
        <template slot-scope="scope">
            <image-wrapper :src="scope.row.twoDimensionCode" style="width: 100px;"></image-wrapper>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-edit"
              circle
              size="small"
              @click="handleUpdate(scope.row)"
            ></el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              size="small"
              @click="handleRemove(scope.row.id)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <detail-box
      @close="closeDialog"
      v-if="isDialog"
      @refresh="refreshList"
      :isEdit="isEdit"
      :form="form"
    ></detail-box>
  </div>
</template>
<script>
import "./store";
import Pagination from "components/pagination";
import { PAGINATION } from "common/config";
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import DetailBox from "./components/detailBox";
import ImageWrapper from 'components/image';
import api from "./api";
export default {
  components: {
    Pagination,
    DetailBox,
    ImageWrapper
  },
  data() {
    return {
      language: 1,
      languageCode: [],
      isDialog: false,
      isEdit: false,
      communityList: [],
      form: {
        account: "",
        communityName: "",
        description: "",
        icon: "",
        language: 1,
        twoDimensionCode: "",
      },
    };
  },
  computed: {
    ...mapState("community", ["languageList"]),
  },
  created() {
    this.refreshList();
  },
  methods: {
    handleSearch() {
      this.refreshList();
    },
    refreshList() {
      api
        .getList({
          language: this.language,
        })
        .then((res) => {
          res.data.forEach((item) => {
            switch (item.language) {
              case 1:
                item.language = "中文";
                break;
              case 3:
                item.language = "韩语";
                break;
              case 4:
                item.language = "英语";
                break;
              case 5:
                item.language = "越南语";
                break;
            }
          });
          this.communityList = res.data;
        });
      this.closeDialog();
    },
    handleUpdate(selected) {
      switch (selected.language) {
        case "中文":
          selected.language = 1;
          break;
        case "韩语":
          selected.language = 3;
          break;
        case "英语":
          selected.language = 4;
          break;
        case "越南语":
          selected.language = 5;
          break;
      }
      this.isEdit = true;
      this.form = selected;
      this.isDialog = true;
    },
    handleRemove(id) {
      api
        .deleteCommunity({
          id: id,
        })
        .then((res) => {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.refreshList();
        });
    },
    handlePageChanged(pagination) {
      this.refreshList(pagination);
    },
    openDialog() {
      this.isDialog = true;
    },
    closeDialog() {
      this.isDialog = false;
      this.isEdit = false;
    },
  },
};
</script>
<style lang="less" scoped>
// .cover{
//   position: absolute;
//   z-index: 2;
//   top: 0;
//   left: 0;
//   right: 0;
//   bottom: 0;
//   background-color: rgba(0, 0, 0, 0.6);
// }
// .box{
//   position: absolute;
//   padding: 20px 40px 40px;
//   width: 500px;
//   top: 20%;
//   left: 50%;
//   margin-left: -290px;
//   z-index: 2;
//   background-color: #fff;
//   border-radius: 10px;
// }
</style>